import {inject, Injectable} from '@angular/core';
import {FloatWidgetFactory} from '../../pages/dashboard/float-layout/float-widget.factory';
import {DexLpTradeWidget} from './dex-lp-trade-widget';
import {DEX_LP_TRADE_WIDGET_TYPE_ID} from './dex-lp-trade-widget-type-id';
import {DexLpTradeWidgetSettingsDef} from './settings';

@Injectable()
export class DexLpTradeWidgetRevealService {

    /**
     * Uses the service, that is provided in the {@link DashboardPageComponent}.
     * Here we can't use this service from the {@link DexLpTradeWidget}, because the widget is already closed.
     */
    private readonly floatWidgetFactory = inject(FloatWidgetFactory);

    public createErrorHandler(widget: DexLpTradeWidget): (error: unknown) => void {
        const wImpl = widget.implementationInstance;
        const origSettingsDef = wImpl.settingsService.toDefinition(wImpl.settings);

        return (error: unknown) => {
            const settingsDef: DexLpTradeWidgetSettingsDef = {
                ...origSettingsDef,
                initialError: error
            };

            this.floatWidgetFactory.createFloatWidget<DexLpTradeWidgetSettingsDef>(
                DEX_LP_TRADE_WIDGET_TYPE_ID,
                settingsDef
            );
        };
    }

}
